export const featuredProduct = {
  key: "covid-19",
  image: "/images/covid.png",
  title: "Compre su Seguro Covid 19 Obligatorio",
  backTitle: "Seguro Covid 19",
  description: "Compre su Seguro Covid 19 Obligatorio.",
  link: "https://socovid.bciseguros.cl/view/DatosContratante.aspx?cn=MwA4ADYA",
  linkLabel: "Compre aquí"
};

const products = [
  {
    key: "building-communities",
    image: "/images/building.jpg",
    title: "Comunidades de Edificio",
    description: "Incendio, para los Espacios Comunes y Unidades, con cláusulas adicionales y misceláneas."
  },
  {
    key: "business-fire",
    image: "/images/fire.jpg",
    title: "Incendio Empresas",
    description: "Con el Seguro Incendio protegerás tu inmueble y su mobiliario, maquinaria y equipo contenido. Este seguro protege además de rayos, otros riesgos aliados y tiene coberturas adicionales que puedes sumar."
  },
  {
    key: "construction-all-risk",
    image: "/images/construction2.jpg",
    title: "Todo Riesgo Construcción",
    description: "Seguro Todo Riesgo de construcción y montaje para empresas. Para asegurar obras en proceso de montaje construcción, puedes contar tanto con la vasta experiencia de Chubb como con su solidez financiera y prevenir riesgos en tu empresa."
  },
  {
    key: "contractor-mobile-equipment",
    image: "/images/crane.jpg",
    title: "Maquinaria Equipo Móvil Contratista",
    description: "Este seguro cubre los daños físicos de la maquinaria y la Responsabilidad Civil por daños corporales y/o materiales causados a terceros por el equipo."
  },
  {
    key: "construction-and-assembly",
    image: "/images/construction.jpg",
    title: "Construcción y Montaje",
    description: "El Seguro de Todo Riesgo de Construcción y Montaje asegura toda clase de obras de ingeniería, como por ejemplo construcción de edificios y carreteras entre otros. Además, en cuanto a estructuras de obras de urbanización, se aseguran estructuras, máquinas, fábricas e industrias."
  },
  {
    key: "guarantee-policy",
    image: "/images/construction3.jpg",
    title: "Póliza de Garantía",
    description: "Se define como Póliza de Garantía, la otorgada por los perjuicios causados al asegurado por no mantener el proveedor los ofrecimientos hechos en su propuesta de licitación, durante la etapa de presentación de la oferta y hasta la suscripción del contrato."
  },
  {
    key: "general-liability",
    image: "/images/suit.jpg",
    title: "Responsabilidad Civil General",
    description: "Este Seguro cubre el pago de las indemnizaciones pecuniarias cuando se es civilmente responsable de terceras personas o las lesiones corporales causadas a las mismas. Cubre los daños materiales causados a terceras personas y también los gastos de defensa, incluso por reclamaciones infundadas."
  },
  {
    key: "professional-liability",
    image: "/images/helmet.jpg",
    title: "Responsabilidad Civil Profesional de Errores y Omisiones",
    description: "Este seguro cubre el patrimonio del Asegurado por las demandas (reclamos) en que resultara civilmente responsable por cometer Errores y/u Omisiones en relación a los Servicios Profesionales que presta a sus clientes. Cubre principalmente a Ingenieros, Arquitectos, Agencias de Publicidad o de Medios, Abogados, entre otros profesionales."
  },
  {
    key: "forestry",
    image: "/images/trees.jpg",
    title: "Forestales para Empresas",
    description: "Es un Seguro de riesgo múltiple que cubre contra fenómenos climáticos y/o antrópicos, permitiéndole al productor forestal recuperar el capital de trabajo invertido en la plantación forestal asegurada, en caso que resulte dañado por alguno de los fenómenos climáticos y/o antrópicos."
  },
  {
    key: "agricultural",
    image: "/images/field.jpg",
    title: "Agrícola",
    description: "Este seguro permite a los agricultores recuperar el capital de trabajo invertido en el cultivo y/o frutal asegurado, en caso que resulte dañado por alguno de los fenómenos climáticos cubiertos por la póliza, logrando una mayor estabilidad económica y mejorando su calidad como sujeto de crédito."
  },
  {
    key: "agricultural-mobile-equipment",
    image: "/images/tractor.jpg",
    title: "Equipo Móvil Agrícola",
    description: "Cubre los daños sufridos durante la ejecución de una obra en construcción, así como la responsabilidad civil asociada a tales trabajos."
  },
  {
    key: "heavy-vehicles-and-fleets",
    image: "/images/fleet.jpg",
    title: "Vehículos Pesados y Flotas",
    description: "Este seguro cubre vehículos tales como: Camiones, Acoplados, Tracto camiones, Remolques, Semirremolques, Ramplas, Chasis, Buses Particulares, Minibuses y similares."
  },
  {
    key: "electronic-equipment",
    image: "/images/device.jpg",
    title: "Equipos Electrónicos",
    description: "Este producto asegura los Equipos Electrónicos de uso particular o comercial (equipos de computación, celulares, comunicaciones, medición, equipos médicos y otros), contra daños físicos. Cobertura a cualquier Daño o Pérdida como consecuencia de un accidente imprevisto y repentino."
  },
  {
    key: "commercial-vessels",
    image: "/images/ship.jpg",
    title: "Embarcaciones Comerciales",
    description: "Es un seguro para embarcaciones de pesqueros de alta mar, pesqueros artesanales, naves de apoyo a la piscicultura y transporte de pasajeros, entre otros, destinado a indemnizar por daños o pérdidas que sufra la nave asegurada."
  },
  {
    key: "domestic-transport",
    image: "/images/truck.jpg",
    title: "Transporte Nacional",
    description: "Es un seguro Nacional orientado a indemnizar pérdidas y/o daños que sufra la materia asegurada (equipos, maquinaria y mercadería general), durante su transporte, ya sea vía marítima, aérea o terrestre (no cubre daños que puedan sucederle a los medios transportadores)."
  },
  {
    key: "international-transport",
    image: "/images/airplane.jpg",
    title: "Transporte Internacional",
    description: "Es un seguro Internacional orientado a indemnizar pérdidas y/o daños que sufra la materia asegurada (equipos, maquinaria y mercadería general), durante su transporte, ya sea vía marítima, aérea o terrestre (no cubre daños que puedan sucederle a los medios transportadores)."
  },
  {
    key: "small-business",
    image: "/images/pyme.jpg",
    title: "Pymes: Mi Pyme",
    description: "Es un seguro multirriesgo que está diseñado para la micro, pequeña y mediana empresa (comercio y oficinas sin procesos productivos) integrando distintas coberturas tendientes a proteger de manera global a la empresa."
  },
  {
    key: "business-protection",
    image: "/images/employer.jpg",
    title: "Protección de Empresas",
    description: "La cobertura base del Seguro Protección Empresa es incendio, la que protege la construcción (edificio - estructura), y/o el contenido, y/o las instalaciones, y/o las maquinarias y/o las existencias. Las demás coberturas son opcionales y se ajustan a las necesidades de cada empresa."
  },
  {
    key: "concierge-life",
    image: "/images/conserje.jpg",
    title: "Vida Conserjes",
    description: "Este seguro cumple con el DS93, Decreto Ley N° 3.607; la normativa establece que los empleadores deberán contratar una póliza de seguro de vida a favor de cada uno de los trabajadores."
  },
  {
    key: "life-with-savings",
    image: "/images/saving.jpg",
    title: "Vida con ahorro",
    description: "Seguro de vida que te ayuda a ahorrar con diversas alternativas de rentabilidad asociadas a tu perfil de riesgo o al plazo de ahorro; además puedes aumentar tu protección contratando coberturas adicionales."
  },
  {
    key: "group-health",
    image: "/images/insurance2.jpg",
    title: "Salud Colectivo",
    description: "Te entregamos un conjunto de coberturas de Vida y/o Salud que otorgan protección a los trabajadores de su empresa y a su grupo familiar."
  }
];

export default products;



// WEBPACK FOOTER //
// ./src/data/products.js